import React from "react";
import { Fragment } from "react";
import { ReactNode } from "react";
import ReactDom, { unmountComponentAtNode } from "react-dom";
import VGPopUp from "../Controls/VGPopUp";

export function GenericConfirmation(prompt:ReactNode,onConfirm:Function,onDismiss:Function,id:string ="confirmationPopup",title="Confirmation",confirmString:string = "OK",cancelString:string = "Cancel",isDestructive:boolean = false,extraOption:string="",onExtra:Function = ()=>{}) {


    const PopupClose = () => {
        let dom = document.getElementById("OpenDialog");
        if (dom) unmountComponentAtNode(dom);
       
    };

        return ReactDom.render(
          <VGPopUp
            id={id}
            show={true}
            onHide={()=>{PopupClose();onDismiss()}}
            title={title}
            dialogClassName="block-edit"
            body={
              <div className="alertContent">
                <p>{prompt}</p>
              </div>
            }
            footer={
              <Fragment>
                {cancelString.length>1 && <button className="w-button w-button-secondary" onClick={() => {PopupClose(); onDismiss();}}>{cancelString}</button>}
                {extraOption.length>1 && <button className="w-button w-button-secondary" onClick={() => {PopupClose(); onExtra();}}>{extraOption}</button>}
                {confirmString.length>1 &&<button className={"w-button w-button-"+(isDestructive?"destructive-outline":"primary")} onClick={(e) => { PopupClose(); onConfirm()}}>{confirmString}</button>}
                
              </Fragment >
            }
            isRemoveTabModalIndex={false}
            isShowFooter={true}
            size={"modal-sm"}
            backdrop={true}
          />,
          document.getElementById("OpenDialog"));
}





export function DestructiveConfirmation(prompt:ReactNode,onDelete:Function,onDismiss:Function = ()=>{},id:string ="deleteItemConfirmation",title="Confirmation",deleteString:string = "Delete",cancelString:string = "Cancel") {

  GenericConfirmation(prompt,onDelete,onDismiss,id,title,deleteString,cancelString,true);

}

export function Confirmation(prompt:ReactNode,onConfirm:Function,onDismiss:Function = ()=>{},id:string ="confirmationPopup",title="Confirmation",deleteString:string = "OK",cancelString:string = "Cancel") {

  GenericConfirmation(prompt,onConfirm,onDismiss,id,title,deleteString,cancelString);

}




export function AlertConfirm(prompt:ReactNode,id:string = "alertModal",title="Alert",confrimString:string = "OK"){

    return GenericConfirmation(prompt,()=>{},()=>{},id,title,confrimString,"");

}